import Factory from './Factory'
import NewsFactory from './NewsFactory'
export default {
  /* 系统设置 */
  SysteamSetting: () => Factory.get('/system-info/platform'),
  /* 用户 */
  Login: data => Factory.post('/passport/login', data),
  Logout: () => Factory.post('/passport/logout'),
  CreateSid: () => Factory.get('/find-password/sid'),
  Captcha: sid => Factory.post('/find-password/captcha', { sid }),
  SendVerifyCode: data => Factory.post('/find-password/send-verify-code', data),
  restPasswod: data => Factory.post('/find-password/reset', data),

  /* 首页 */
  Semester: () => Factory.get('/semester'),
  HomeDocsList: params => Factory.get('/docs-manage/index', { params }),
  EECourseCalendar: data => Factory.post('/ee/course/course-calendar', data), // 首页日历数据
  MBACourseCalendar: data => Factory.post('/mba/course/course-calendar', data), // 首页日历数据
  AssessmentTips: () => Factory.get('/mba/course/assessment-tips'), // 首页课程评估强制提醒

  /* 常用文档 */
  DocsTree: () => Factory.get('/docs-manage/documents'),
  DocsList: params => Factory.get('/docs-manage/files', { params }),
  DownLoadDocs: params => Factory.get('/docs-manage/download', { params }), // 下载文档

  /* 我的课程 */
  MBACourseTable: data => Factory.post('/mba/course/course-tables', data),
  MBACourseTime: params => Factory.get('/mba/course/course-times', { params }), // 上课时间
  MBACourseInfoAndFile: params => Factory.get('/mba/course/course-files', { params }), // 课程资料
  EEProject: () => Factory.get('/ee/project'),
  EECourseTable: data => Factory.post('/ee/course/course-tables', data),
  EECourseTime: params => Factory.get('/ee/course/course-times', { params }), // 上课时间
  EECourseInfoAndFile: params => Factory.get('/ee/course/course-files', { params }), // 课程资料
  schoolYearSemesters: params => Factory.get('/semester/school-year-semesters', { params }), // 获取学年下的学期
  MBAUserPlan: () => Factory.get('/mba/plan'), // 培养计划
  getAssessmentList: data => Factory.post('/mba/course/assessment', data), // 获取评估列表
  getUnAssessmentStu: data => Factory.post('/mba/course/un-assessment-student', data), // 获取未评估学生

  myHomeworkList: params => Factory.post('/mba/homework/index', params),
  myHomeworkUpload: params => Factory.post('/mba/homework/submit-homework', params),

  assessment: params => Factory.get('/assessment', { params }), // 获取评估表配置
  assessmentSaveRecord: data => Factory.post('/assessment/save-record', data), // 提交评估

  /* 个人中心 */
  UserPortalData: () => Factory.get('/user/portal-data'),
  userInfo: () => Factory.get('/user/info'),
  UpdateInfo: data => Factory.post('/user/update-info', data),
  ChangePassWord: data => Factory.post('/user/change-pwd', data),
  // 修改手机号
  createCodeSid: () => Factory.get('/user/sid'),
  sendCode: data => Factory.post('/user/verify-code', data),
  upDatePhone: data => Factory.post('/user/update-phone', data),

  // /student-api/v1/mba/student-pay/get-pay-url
  payUrl: () => Factory.get('/mba/student-pay/get-pay-url'),
  payReport: () => Factory.get('/mba/student-pay/get-pay-report'),
  payPlan: () => Factory.get('/mba/student-pay/get-pay-plan'),

  /* Common */
  uploadFile: data => Factory.post('/upload', data),

  /* Other */
  getActivityLists: params => Factory.get('/activity', { params }),
  actSignUp: data => Factory.post('/activity/apply', data),
  cancelActSignUp: data => Factory.post('/activity/cancel-apply', data),
  myActivityList: params => Factory.get('/activity/my-activity', { params }),
  activityDetail: params => Factory.get('/activity/detail', { params }),

  myActivityhomeworkList: params => Factory.post('/activity-homework/index', params),
  myActivityhomeworkUpload: params => Factory.post('/activity-homework/upload-homework', params),

  // /content/getNewsLists
  getNewsLists: data => NewsFactory.post('/content/getNewsLists', data),

  /* 查看停课原因 */
  MBAshowStopCourseReason: params => Factory.get('/mba/course/course-stop-info', { params }),
  // 查看课表调课原因
  MBAshowCourseChange: params => Factory.get('/mba/course/course-change-info', { params }),
  MBAshowExtraCourse: params => Factory.get('/mba/course/course-extra-info', { params }),

  EEshowStopCourseReason: params => Factory.get('/ee/course/course-stop-info', { params }),
  // 查看课表调课原因
  EEshowCourseChange: params => Factory.get('/ee/course/course-change-info', { params }),
  EEshowExtraCourse: params => Factory.get('/ee/course/course-extra-info', { params }),

  // 查看考试安排
  MBAExamInfoSet: params => Factory.get('/mba/course/exam-set', { params }),

  // 课程调整申请
  MBAApplyCourseChange: params => Factory.get('/mba/apply/course-change', { params }),
  MBAApplyCourseChangePrepare: () => Factory.get('/mba/apply/course-change-prepare'),
  MBACourseByType: params => Factory.get('/mba/course/course-by-type', { params }),
  MBACourseChangeApply: data => Factory.post('/mba/apply/course-change-apply', data),
  MBACourseChangeCancel: params => Factory.get('/mba/apply/course-change-cancel', { params }),
  MBACourseChangeDetail: params => Factory.get('/mba/apply/course-change-detail', { params }),

  // 选课
  primaryCourse: params => Factory.get('/mba/course-choose-batch/index', { params }),
  primaryCourseList: params => Factory.get('/mba/course-choose-batch/course-list', { params }),
  primaryCourseSelect: data => Factory.post('/mba/course-choose-batch/do-select-course', data),

  // 论文管理
  MBAThesisNoticeList: () => Factory.get('/mba/thesis/notice/lists'),
  MBAThesisNoticeDetail: id => Factory.get(`/mba/thesis/notice/detail?id=${id}`),
  MBAThesisNodeConfig: node => Factory.get(`/mba/thesis/sel-teacher/get-config?node=${node}`),
  MBAThesisTutorData: () => Factory.post('/mba/thesis/sel-teacher/show'),
  MBAThesisTutorList: (data) => Factory.post('/mba/thesis/sel-teacher/tutor-list', data),
  MBAThesisTutorSubmit: (data) => Factory.post('/mba/thesis/sel-teacher/sel-submit', data),
  MBAThesisNodeList: () => Factory.get('/mba/thesis/paper/get-node-list'),
  MBAThesisDirectionList: () => Factory.get('/mba/thesis/paper/direction-list'),
  MBAThesisProcessInfo: data => Factory.post('/mba/thesis/paper/node-show', data),
  MBAThesisProcessSubmit: data => Factory.post('/mba/thesis/paper/node-submit', data),
  MBAThesisStepSubmit: data => Factory.post('/mba/thesis/sel-teacher/step-update', data),

  getNoticesLists: data => Factory.post('/mba/notice', data),
  getValueMaps: data => Factory.post('/dba/publics/value-maps', data),
  getGraduationArchives: () => Factory.get('/mba/graduation-archives'),
  updateGraduationArchives: data => Factory.post('/mba/graduation-archives/update', data),
  udpateGraguationArchivesState: data => Factory.post('/mba/graduation-archives/state-update', data)
}
